import React, { useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, NavLink } from 'react-router-dom';
import './navbar.css';
import logo from '../../assets/d97ae9ac8355a0d5876385dc4a41e6c7af024c07.jpg';
import { FaHome, FaInfoCircle, FaServicestack, FaBriefcase, FaEnvelope } from 'react-icons/fa';
import whatsapp from "../../assets/WhatsApp.svg.png";
import call from "../../assets/call-answer-01.png";

const Navbar = () => {
  const navbarRef = useRef(null);

  useEffect(() => {
    const navLinks = document.querySelectorAll('.nav-link');
    const toggleButton = document.querySelector('.navbar-toggler');
    const navbarCollapseEl = navbarRef.current;

    const handleNavLinkClick = (e) => {
      navLinks.forEach(link => link.classList.remove('active'));
      e.target.classList.add('active');
      if (navbarCollapseEl.classList.contains('show')) {
        navbarCollapseEl.classList.remove('show');
      }
    };

    const handleToggleClick = () => {
      navbarCollapseEl.classList.toggle('show');
    };

    navLinks.forEach(link => {
      link.addEventListener('click', handleNavLinkClick);
    });
    toggleButton.addEventListener('click', handleToggleClick);

    return () => {
      navLinks.forEach(link => {
        link.removeEventListener('click', handleNavLinkClick);
      });
      toggleButton.removeEventListener('click', handleToggleClick);
    };
  }, []);

  return (
    <>

      <nav className="navbar navbar-expand-lg fixed-top navbar-custom">
        <div className="container navbar-container-page">
          <Link className="navbar-brand" to="/">
            <img src={logo} width={130} height={50} alt="Logo" />
          </Link>

          <button className="navbar-toggler" type="button">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" ref={navbarRef} id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <NavLink className="nav-link" to="/" end>
                  <FaHome className="me-2" /> Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/aboutmain">
                  <FaInfoCircle className="me-2" /> About Us
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/servicepage">
                  <FaServicestack className="me-2" /> Service
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/branding">
                  <FaBriefcase className="me-2" /> Portfolio
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/contact">
                  <FaEnvelope className="me-2" /> Contact Us
                </NavLink>
              </li>
            </ul>

          </div>


        </div>
      </nav>
      <section>

        <div className="main-icons">
          <ul className="first">
            <li className="color1">
              <a href="tel:+918778934301">
                <p>Call <br />+91 8778934301</p>
                <img src={call} width="20px" height="20px" className="img-fluid" />
              </a>
            </li>
            <li className="color2">
              <a href="https://api.whatsapp.com/send?phone=918778934301" target="_blank">
                <p>Whatsapp <br />+91 8778934301</p>
                <img src={whatsapp} width="24" height="24" className="img-fluid" />
              </a>
            </li>
            {/* <li className="color3">
                          <a
                            href="https://maps.app.goo.gl/W9jNi6VWGbfWmbB57"
                            target="_blank"
                            rel="noopener noreferrer" // Best practice for opening new tabs
                          >
                            <p style={{ color: "black" }}>Location <br />First Sky Infra</p>
                            <img src={map} width="30" height="30" className="img-fluid1" alt="Map Icon" />
                          </a>
                        </li> */}

          </ul>
        </div>
      </section>
    </>
  );
};

export default Navbar;
